import { isPreproduction, isProduction } from './../../../env'
import { imageAsset, mediaAsset, nonBookableDates, productId, referencedByPgPageCondition } from './helpers'

export const productQuery = (id: string, source: string) => {
  return `*[_type == "smProduct"${
    isProduction || isPreproduction ? ' && publishSpace == true' : ''
  } && ${productId} == "${id}" && source == "${source}"  && isWorkspaceCard != true && ${referencedByPgPageCondition}]{
    name,
    source,
    "platformId": ${productId},
    description,
    images[]->${imageAsset},
    media[]->${mediaAsset},
    inquiryOnly,
    "building": buildingRef->slug.current,
    capacity,
    "type": spaceType,
    slug,
    "nonBookableDates": buildingRef->{ nonBookableDates->${nonBookableDates}}
  }[0]`
}
